import API from "../Common/Endpoint/serviceConstrants";
import axiosIntegrationOtp from "../Common/Axios/axiosIntegrationOtp";
export const validateOtpApi = async (payload,header) => {
    const { data = {} } = await axiosIntegrationOtp.post(API.validateOtp, payload,{headers: header});
  return data;
};
